/* eslint-disable react/no-multi-comp */
import { Box, Typography } from '@customink/pigment-react';
import { type FullQuote } from '@customink/project-service-react-components';

import type { ShippingOption } from '@/components/DeliveryOptions/util';
import { colorPurple } from '@/utils/designTokens';

type ShippingLabelProps = {
  shippingOption: ShippingOption;
  quote?: FullQuote;
};

export default function ShippingOptionLabel({
  shippingOption,
  quote,
}: ShippingLabelProps) {
  const option = quote?.[shippingOption.key];
  const charge: string = !!option?.charge
    ? `- Add ${option.charge}`
    : '- FREE!';

  const { delivery_date, order_by_deadline: orderBy } = option || {};

  const hasAdjustment = !!quote?.turn_adjustment;

  return (
    <Box data-testid="shipping-option-label">
      <Typography
        component="div"
        sx={{ fontWeight: 'bold' }}
        variant="uiTextSmall"
      >
        {shippingOption.name} {charge}
      </Typography>
      {!!option && (
        <>
          <Typography component="div" variant="uiTextTiny">
            {` Get it by end of day `}
            {!!delivery_date && (
              <Typography
                component="div"
                sx={{
                  fontWeight: 'bold',
                  display: 'inline-block',
                }}
                variant="uiTextTiny"
              >
                {` ${delivery_date}`}
                {hasAdjustment && <span style={{ color: colorPurple }}>*</span>}
              </Typography>
            )}
            {!!orderBy && <>{` - ${orderBy}`}</>}
          </Typography>
        </>
      )}
    </Box>
  );
}
